import { Component} from '@angular/core';
import { Sidenav } from "./sidenav/sidenav";
import { Header } from './header/header';
import { RouterOutlet } from '@angular/router';
import { DrawerModule } from 'primeng/drawer';
import { SpinnerComponent } from '../../@shared/components/spinner/spinner-component/spinner-component';

@Component({
  selector: 'app-main-layout',
  imports: [RouterOutlet, Sidenav, Header, DrawerModule, SpinnerComponent],
  templateUrl: './main-layout.html',
  styleUrl: './main-layout.scss'
})
export class MainLayout {
  drawerVisible = false;

  toggleDrawer() {
    this.drawerVisible = !this.drawerVisible;
  }
}
